import { CommonService } from './../../../../provide/common.service';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CustomValidators } from 'src/app/provide/Validators';

@Component({
  selector: 'app-business-details-service-provider',
  templateUrl: './business-details-service-provider.component.html',
  styleUrls: ['./business-details-service-provider.component.scss'],
  standalone: false
})
export class BusinessDetailsServiceProviderComponent implements OnInit {
  heroes = ['Windstorm', 'Bombasto', 'Magneta', 'Tornado'];
  businessform!: UntypedFormGroup;
  products: any = [];
  showInputes: boolean = false;
  showInput: boolean = false;
  isVatRegistered: boolean | any;
  addNewSubcategoryField: any = [];
  addNewSubcategoryBussinessField: any = [];
  countryCode = new UntypedFormControl('+27');
  brandName: any;
  serviceRole: string;
  isSubmitted = false;
  userType: string;
  signupTitle: string;
  constructor(
    public commonService: CommonService,
    private http: HttpClient,
    private router: Router,
    private toastrService: ToastrService
  ) {
    this.serviceRole = localStorage.getItem('serviceRole');
    if (this.serviceRole == 'PICKUP') {
      this.signupTitle = 'Pickup Partner detail';
      this.userType = 'PICKUP_PARTNER';
    } else if (this.serviceRole == 'DELIVERY') {
      this.signupTitle = 'Signup As delivery Driver';
      this.userType = 'DELIVERY_PARTNER';
    } else if (this.serviceRole == 'FIELD') {
      this.signupTitle = 'Signup As field entity';
      this.userType = 'FIELD_ENTITY';
    } else {
      this.signupTitle = 'Signup As Service Provider';
      this.userType = 'SERVICE_PROVIDER';
    }
  }

  ngOnInit(): void {
    const userDetailString = localStorage.getItem('userDetail');
    const userDetail = JSON.parse(userDetailString);
    let email = userDetail ? userDetail.email : ""
    let firstName = userDetail ? userDetail.firstName : ""
    let lastName = userDetail ? userDetail.lastName : ""
    let phoneNumber = userDetail ? userDetail.phoneNumber : ""

    console.log(userDetail, 'useeee');

    this.addNewSubCategryDynamic();
    // this.addNewSubCategryBussinessDynamic();
    const custonValidation = new CustomValidators()
    this.businessform = new UntypedFormGroup({
      fName: new UntypedFormControl(firstName, custonValidation.name()),

      lName: new UntypedFormControl(lastName, custonValidation.name()),

      email: new UntypedFormControl(email, custonValidation.email()),

      // Match retailer business details validation
      company: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(100),
        Validators.pattern(/^[a-zA-Z0-9\s.\-]+$/)
      ]),

      businessRegNumber: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(30),
        Validators.pattern(/^[a-zA-Z0-9]+$/)
      ]),
      // cotegory: new FormControl('', [
      //   Validators.required,
      //
      // ]),
      url: new UntypedFormControl('', custonValidation.url()),

      vatRegistered: new UntypedFormControl('', custonValidation.vatNumber()),

      // vatNumberInput: new FormControl('', [
      //   Validators.required,
      // ]),

      monthlyRevenue: new UntypedFormControl(''),

      bankname: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(60),
        Validators.pattern(/^[a-zA-Z\s]+$/)
      ]),

      branchname: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(80),
        Validators.pattern(/^[a-zA-Z0-9\s]+$/)
      ]),
      swiftcode: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(/^[A-Z0-9]{8}$|^[A-Z0-9]{11}$/),
      ]),
      accountType: new UntypedFormControl('', [Validators.required]),
      accountName: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(100),
        Validators.pattern(/^[a-zA-Z0-9\s]+$/)
      ]),
      accountNumber: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(/^[0-9]+$/),
        Validators.minLength(5),
        Validators.maxLength(17)
      ]),
    });
    this.http.get('assets/countrycode.json').subscribe((data) => {
      this.products = data['result'];
    });
    // this.getValidation()
  }

  getValidation() {
    if (this.serviceRole != 'SERVICE') {
      this.businessform.removeControl('company');
      this.businessform.removeControl('businessRegNumber');
      this.businessform.removeControl('monthlyRevenue');
      this.businessform.removeControl('url');
      this.businessform.removeControl('vatRegistered');
      this.businessform.removeControl('vatNumberInput');

      if (this.serviceRole != 'FIELD') {
        this.businessform.addControl(
          'licenceNumber',
          new UntypedFormControl('', Validators.required)
        );
        this.businessform.addControl(
          'vehicleRegistartionNumber',
          new UntypedFormControl('', Validators.required)
        );
        this.businessform.addControl(
          'vehicleModel',
          new UntypedFormControl('', Validators.required)
        );
        this.businessform.addControl(
          'vehicleYear',
          new UntypedFormControl('', Validators.required)
        );
        this.businessform.addControl(
          'vehicleType',
          new UntypedFormControl('', Validators.required)
        );
        this.businessform.addControl(
          'vehicleColour',
          new UntypedFormControl('', Validators.required)
        );
        this.businessform.addControl(
          'insuranceNumber',
          new UntypedFormControl('', Validators.required)
        );
      } else {
        this.businessform.addControl(
          'buisnessName',
          new UntypedFormControl('', Validators.required)
        );
        this.businessform.addControl(
          'buisnessType',
          new UntypedFormControl('', Validators.required)
        );
        this.businessform.addControl(
          'buisnessAddress',
          new UntypedFormControl('', Validators.required)
        );
        this.businessform.addControl('buisnessWebsite', new UntypedFormControl(''));
        this.businessform.addControl(
          'buisnessEmail',
          new UntypedFormControl('', [
            Validators.required,
            Validators.pattern(
              /^([a-zA-Z0-9_\-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/i
            )

          ])
        );
        this.businessform.addControl(
          'einNum',
          new UntypedFormControl('', Validators.required)
        );
        this.businessform.addControl(
          'monthlyOrderVolume',
          new UntypedFormControl('', Validators.required)
        );
        this.businessform.addControl('salesTaxId', new UntypedFormControl(''));
      }
    }
  }
  addNewSubCategryDynamic() {
    if (
      this.addNewSubcategoryField.length &&
      this.addNewSubcategoryField[this.addNewSubcategoryField.length - 1]
        .sub_Category_List == ''
    ) {
      return this.commonService.infoToast(
        'Please enter the value in previous added, after that click on add new.'
      );
    }
    this.addNewSubcategoryField.push({
      sub_Category_List: '',
    });
  }

  removeBodySectionDynamic(index: number) {
    this.addNewSubcategoryField.splice(index, 1);
  }

  businessDetaile() {
    if (this.businessform.invalid) {
      this.isSubmitted = true;
      this.commonService.errorToast('Please fill all required fields.');
      return;
    }
    let subCategoryData = this.addNewSubcategoryField.map((x: any) => {
      return x.sub_Category_List;
    });
    let emptyString = subCategoryData.includes('');
    var fillDetails = {
      ownerFirstName: this.businessform.value.fName,
      ownerLastName: this.businessform.value.lName,
      ownerEmail: this.businessform.value.email,
      businessBankingDetails: {
        bankName: this.businessform.value.bankname,
        branchName: this.businessform.value.branchname,
        // "branchCode": "string",
        swiftCode: this.businessform.value.swiftcode,
        accountType: this.businessform.value.accountType,
        accountName: this.businessform.value.accountName,
        accountNumber: this.businessform.value.accountNumber,
      },

      businessDetails: {
        companyName: this.businessform.value.company,
        businessRegNumber: this.businessform.value.businessRegNumber,
        // "categoryId": "string",
        websiteUrl: this.businessform.value.url,
        socialMediaAccounts: 'string',
        isVatRegistered: this.businessform.value.vatNumberInput ? true : false,
        vatNumber: this.businessform.value.vatNumberInput,
        monthlyRevenue: this.businessform.value.monthlyRevenue,

        // "storeAddress": this.businessform.value.storeessed,
        // "storeName": this.businessform.value.storeess,
        // "storeContactNo": this.businessform.value.storesgg,
      },

      flag: 1,
      userType: 'SERVICE_PROVIDER',
      // "preferredSupplierOrWholeSalerId": selectedCarObjS
    };
    this.commonService.showSpinner();
    this.commonService.postApi('user/fillDetails', fillDetails, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.commonService.hideSpinner();

          if (
            res.result.completeProfile &&
            res.result.userRequestStatus == 'PENDING' &&
            res.result.flag == 0
          ) {
            this.router.navigate(['/service-provider-select-role']);
          } else if (!res.result.completeProfile) {
            this.toastrService.success(res['responseMessage']);
            // this.commonService.successToast(res['responseMessage']);
            this.router.navigate(['/service-provider-select-role']);
          }
          // set current url to localstorage
          // this.router.navigate(['/upload-documentation']);

          // this.currentUrl = this.route.url;
          // localStorage.setItem('token', res.result.token)
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        this.toastrService.error('Please fill in all the required fields.');
        this.commonService.errorToast(err.error['responseMessage']);
      }
    );
  }
  pickupDetaile() {
    let subCategoryData = this.addNewSubcategoryField.map((x: any) => {
      return x.sub_Category_List;
    });
    let emptyString = subCategoryData.includes('');
    var fillDetails = {
      ownerFirstName: this.businessform.value.fName,
      ownerLastName: this.businessform.value.lName,
      ownerEmail: this.businessform.value.email,
      businessBankingDetails: {
        bankName: this.businessform.value.bankname,
        branchName: this.businessform.value.branchname,
        // "branchCode": "string",
        swiftCode: this.businessform.value.swiftcode,
        accountType: this.businessform.value.accountType,
        accountName: this.businessform.value.accountName,
        accountNumber: this.businessform.value.accountNumber,
      },

      driverDetail: {
        licenceNumber: this.businessform.value.licenceNumber,
        vehicleRegistartionNumber:
          this.businessform.value.vehicleRegistartionNumber,
        vehicleModel: this.businessform.value.vehicleModel,
        vehicleYear: this.businessform.value.vehicleYear,
        vehicleType: this.businessform.value.vehicleType,
        vehicleColour: this.businessform.value.vehicleColour,
        insuranceNumber: this.businessform.value.insuranceNumber,
      },

      flag: 1,
      userType: this.userType,
      // "preferredSupplierOrWholeSalerId": selectedCarObjS
    };
    this.commonService.showSpinner();
    this.commonService.postApi('user/fillDetails', fillDetails, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          // this.commonService.successToast(res['responseMessage'])
          // localStorage.setItem('email', this.businessform.value.email)
          this.commonService.hideSpinner();

          if (
            res.result.completeProfile &&
            res.result.userRequestStatus == 'PENDING' &&
            res.result.flag == 0
          ) {
            this.router.navigate(['/upload-document-service-provider']);
          } else if (!res.result.completeProfile) {
            this.commonService.successToast(res['responseMessage']);
            this.router.navigate(['/upload-document-service-provider']);
          }
          // set current url to localstorage
          // this.router.navigate(['/upload-documentation']);

          // this.currentUrl = this.route.url;
          // localStorage.setItem('token', res.result.token)
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        this.commonService.errorToast(err.error['responseMessage']);
      }
    );
  }

  fieldDetaile() {
    let subCategoryData = this.addNewSubcategoryField.map((x: any) => {
      return x.sub_Category_List;
    });
    let emptyString = subCategoryData.includes('');
    var fillDetails = {
      ownerFirstName: this.businessform.value.fName,
      ownerLastName: this.businessform.value.lName,
      ownerEmail: String(this.businessform.value.email).toLowerCase(),
      businessBankingDetails: {
        bankName: this.businessform.value.bankname,
        branchName: this.businessform.value.branchname,
        // "branchCode": "string",
        swiftCode: this.businessform.value.swiftcode,
        accountType: this.businessform.value.accountType,
        accountName: this.businessform.value.accountName,
        accountNumber: this.businessform.value.accountNumber,
      },

      fieldEntityDetails: {
        businessName: this.businessform.value.buisnessName,
        businessType: this.businessform.value.buisnessType,
        businessAddress: this.businessform.value.buisnessAddress,
        businessWebsite: this.businessform.value.buisnessWebsite,
        businessEmail: this.businessform.value.buisnessEmail,
        einNum: this.businessform.value.einNum,
        salesTaxId: this.businessform.value.monthlyOrderVolume,
        monthlyOrderVolume: this.businessform.value.salesTaxId,
      },

      flag: 1,
      userType: this.userType,
      // "preferredSupplierOrWholeSalerId": selectedCarObjS
    };
    this.commonService.showSpinner();
    this.commonService.postApi('user/fillDetails', fillDetails, 1).subscribe(
      (res: any) => {
        if (res['responseCode'] == 200) {
          this.commonService.successToast(res['responseMessage']);
          // localStorage.setItem('email', this.businessform.value.email)
          this.commonService.hideSpinner();

          if (
            res.result.completeProfile &&
            res.result.userRequestStatus == 'PENDING' &&
            res.result.flag == 0
          ) {
            this.router.navigate(['/upload-document-service-provider']);
          } else if (!res.result.completeProfile) {
            this.commonService.successToast(res['responseMessage']);
            this.router.navigate(['/upload-document-service-provider']);
          }
          // set current url to localstorage
          // this.router.navigate(['/upload-documentation']);

          // this.currentUrl = this.route.url;
          // localStorage.setItem('token', res.result.token)
        }
      },
      (err) => {
        this.commonService.hideSpinner();
        // this.toastrService.error("Please fill in all the required fields.");
        this.commonService.errorToast(err.error['responseMessage']);
      }
    );
  }

  open() {
    const customValidation = new CustomValidators()
    this.businessform.addControl(
      'vatNumberInput',
      new UntypedFormControl('', [Validators.required, ...customValidation.vatNumber()])
    );

    this.showInput = !this.showInput;
  }

  close() {
    this.businessform.removeControl('vatNumberInput');

    this.showInput = false;
  }

  openesd() {
    this.showInputes = !this.showInputes;
  }

  closeesd() {
    this.showInputes = false;
  }

  // serchlistApi

  // addNewSubCategryBussinessDynamic() {
  //   if (this.wholeSalerList.length && this.wholeSalerList[this.wholeSalerList.length - 1].sub_Category_List == '') {
  //     return this.commonService.infoToast('Please enter the value in previous added, after that click on add new.')
  //   }
  //   this.wholeSalerList.push({
  //     sub_Category_List: ''
  //   })
  // }
  valueName: any;
  srarchWholeSaler: any;
  nameArray: any = [];
  selectedCarObjS: any = [];
  arrayVlaue: any = [];
  srarchWholeSalers = '';

  selectedCarObj: any = [];

  removeSearchDynamic(index: number) {
    this.selectedCarObjS.splice(index, 1);
  }
  wholeSalerList: any = [];

  /** Function to restrict character */
  restrictChar(event: any) {
    var k = event.charCode;
    if (event.key === 'Backspace') k = 8;
    if ((k >= 48 && k <= 57) || k == 8 || k == 46) return true;
    else return false;
  }

  NumOnly(event: any) {
    // Allow only digits (0-9) and control keys like backspace, delete, etc.
    const pattern = /^[0-9]$/;
    const inputChar = String.fromCharCode(event.charCode);

    // Allow control keys (backspace, delete, arrows, etc.)
    if (event.keyCode === 0 || event.keyCode === 8) {
      return true;
    }

    if (!pattern.test(inputChar)) {
      // If the character doesn't match the pattern, prevent the input
      event.preventDefault();
      return false;
    }
    return true;
  }

  preventSpace(event: any) {
    if ((event.charCode == 32 || event.charCode == 64) && !event.target.value) {
      event.preventDefault();
    }
  }

  // Company name: letters, numbers, spaces, hyphens, dots
  allowCompanyName(event: any) {
    const pattern = /^[a-zA-Z0-9\s.\-]$/;
    const inputChar = String.fromCharCode(event.charCode);

    // Allow control keys (backspace, delete, arrows, etc.)
    if (event.keyCode === 0 || event.keyCode === 8 || event.keyCode === 46) {
      return true;
    }

    if (!pattern.test(inputChar)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  // Business Registration Number: alphanumeric only (no spaces)
  allowAlphanumericOnly(event: any) {
    const pattern = /^[a-zA-Z0-9]$/;
    const inputChar = String.fromCharCode(event.charCode);

    // Allow control keys (backspace, delete, arrows, etc.)
    if (event.keyCode === 0 || event.keyCode === 8 || event.keyCode === 46) {
      return true;
    }

    if (!pattern.test(inputChar)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  // Bank Name: only alphabets and spaces
  allowAlphabetsAndSpaces(event: any) {
    const pattern = /^[a-zA-Z\s]$/;
    const inputChar = String.fromCharCode(event.charCode);

    // Allow control keys (backspace, delete, arrows, etc.)
    if (event.keyCode === 0 || event.keyCode === 8 || event.keyCode === 46) {
      return true;
    }

    // Prevent space at the beginning
    if (inputChar === ' ' && !event.target.value) {
      event.preventDefault();
      return false;
    }

    if (!pattern.test(inputChar)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  // Branch Name and Account Name: letters, numbers, spaces
  allowAlphanumericAndSpaces(event: any) {
    const pattern = /^[a-zA-Z0-9\s]$/;
    const inputChar = String.fromCharCode(event.charCode);

    // Allow control keys (backspace, delete, arrows, etc.)
    if (event.keyCode === 0 || event.keyCode === 8 || event.keyCode === 46) {
      return true;
    }

    // Prevent space at the beginning
    if (inputChar === ' ' && !event.target.value) {
      event.preventDefault();
      return false;
    }

    if (!pattern.test(inputChar)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  // ===================

  totalItems: any;

  getcontents($event: any) {
    this.commonService.getApi('user/listCountry', 0).subscribe(
      (res: any) => {
        this.commonService.showSpinner();
        if (res['responseCode'] == 200) {
          // this.categoryListArray = res['result']

          this.totalItems = res['result'];
          this.commonService.hideSpinner();
          // this.commonService.successToast(res.responseMessage);
        } else {
          this.products = [];
          this.commonService.hideSpinner();
          this.commonService.errorToast(res.responseMessage);
        }
      },
      (err) => {
        this.commonService.warningToast(err['error']['responseMessage']);
      }
    );
  }
  loading = false;

  load() {
    this.loading = true;

    setTimeout(() => {
      this.loading = false;
    }, 60000); // 1 minute
  }

  toUpperCase(event: any) {
    event.target.value = event.target.value.toUpperCase();
  }
}


